var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"h4"},[_vm._v("Times")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.times)}})])}
var staticRenderFns = []

export { render, staticRenderFns }